// src/components/layout/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="fixed bottom-0 right-0 p-2 text-xs text-gray-500 z-10">
      <div className="flex gap-3">
        <Link 
          to="/privacy" 
          className="hover:text-gray-700 hover:underline transition-colors"
        >
          Privacy
        </Link>
        <span>|</span>
        <Link 
          to="/terms" 
          className="hover:text-gray-700 hover:underline transition-colors"
        >
          Usage Terms
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
